import type { ComponentType } from 'react';
import { createSelector } from 'reselect';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { saveAvatarImage, showFetchAvatarsErrorFlag } from '../state/actions.tsx';
import {
	getAvatars,
	getSelectedAvatar,
	getIsOpen,
	getOnAvatarSelected,
	getOnDismiss,
	getIsSaving,
	getFetchError,
} from '../state/selectors.tsx';
import type { State } from '../state/types.tsx';
import { AvatarModal, type Props } from './view.tsx';

type StateProps = Pick<
	Props,
	| 'onAvatarSelected'
	| 'onDismiss'
	| 'avatars'
	| 'selectedAvatar'
	| 'isOpen'
	| 'isSaving'
	| 'fetchError'
>;

const getSelectedAvatarSelectorMemoized = () => createSelector(getSelectedAvatar, (res) => res);

const mapStateToPropsFactory = (): ((state: State) => StateProps) => {
	const getSelectedAvatarSelectorInstance = getSelectedAvatarSelectorMemoized();
	return (state: State) => ({
		onAvatarSelected: getOnAvatarSelected(state),
		onDismiss: getOnDismiss(state),
		avatars: getAvatars(state),
		selectedAvatar: getSelectedAvatarSelectorInstance(state),
		isOpen: getIsOpen(state),
		isSaving: getIsSaving(state),
		fetchError: getFetchError(state),
	});
};

type DispatchProps = Pick<Props, 'onSaveImage' | 'onShowFetchAvatarsErrorFlag'>;

const mapDispatchToProps: DispatchProps = {
	onSaveImage: saveAvatarImage,
	onShowFetchAvatarsErrorFlag: showFetchAvatarsErrorFlag,
};

type OwnProps = {};

const Connected: ComponentType<OwnProps> = connect(
	mapStateToPropsFactory,
	mapDispatchToProps,
)(AvatarModal);

export default Connected;
